import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function FinalCTA() {
  const checklist = ['Sin horno (sin baño María)', 'Listos en 15 minutos (producción por tandas)', 'Recetas probadas (sin "relleno")', 'Salsas para subir ticket', 'Guiones para vender sin vergüenza', 'Acceso inmediato por email'];
  return <section className="py-10 md:py-20 px-4 bg-brown-dark text-cream" data-id="element-58">
      <div className="max-w-4xl mx-auto text-center" data-id="element-59">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-caramel mb-4 md:mb-6" data-id="element-60">
          ¿Qué hace que este método sea "perfecto"?
        </h2>

        <p className="text-xl text-gray-300 font-medium mb-6 md:mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-61">
          Tiene que ser lo suficientemente simple para hacerlo en casa… pero lo
          suficientemente claro para que puedas repetirlo y convertirlo en un
          extra real.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left max-w-2xl mx-auto mb-10 md:mb-16" data-id="element-62">
          {checklist.map((item, i) => <div key={i} className="flex items-center bg-brown-dark/50 border border-caramel/20 p-4 rounded-lg" data-id="element-63">
              <CheckCircleIcon className="w-6 h-6 text-success-green mr-3 flex-shrink-0" data-id="element-64" />
              <span className="font-medium" data-id="element-65">{item}</span>
            </div>)}
        </div>

        <div className="bg-cream-dark text-brown-dark rounded-3xl p-6 md:p-12 max-w-2xl mx-auto shadow-2xl" data-id="element-66">
          <h3 className="font-heading font-bold text-2xl mb-4 md:mb-6" data-id="element-67">
            Una vez más, todo lo que recibirás
          </h3>

          <ul className="text-left space-y-3 mb-6 md:mb-8 font-medium" data-id="element-68">
            <li className="flex items-center" data-id="element-69">
              <span className="w-2 h-2 bg-caramel rounded-full mr-3" data-id="element-70"></span>{' '}
              Flanes Sin Horno (método completo)
            </li>
            <li className="flex items-center" data-id="element-71">
              <span className="w-2 h-2 bg-caramel rounded-full mr-3" data-id="element-72"></span> 7
              bonos incluidos GRATIS
            </li>
            <li className="flex items-center" data-id="element-73">
              <span className="w-2 h-2 bg-caramel rounded-full mr-3" data-id="element-74"></span>{' '}
              Acceso inmediato por email
            </li>
            <li className="flex items-center" data-id="element-75">
              <span className="w-2 h-2 bg-caramel rounded-full mr-3" data-id="element-76"></span>{' '}
              Garantía "FACTURÁ O DÉJALO" de 7 días
            </li>
          </ul>

          <div className="border-t border-gray-200 pt-6 mb-6" data-id="element-77">
            <p className="text-gray-500 font-bold uppercase text-sm mb-1" data-id="element-78">
              Valor total: <span className="line-through" data-id="element-79">US$184+</span>
            </p>
            <p className="text-lg font-bold text-brown-dark mb-2" data-id="element-80">
              Pago único hoy:
            </p>
            <PriceDisplay showOriginal={false} data-id="element-81" />
          </div>

          <a href="#pricing-cta" className="block w-full bg-cta-green hover:bg-green-700 text-white font-heading font-bold text-2xl py-5 px-8 rounded-xl shadow-[0_10px_20px_rgba(22,163,74,0.3)] transition-all transform hover:-translate-y-1 animate-pulse-glow" data-id="element-82">
            AGREGAR AL CARRITO »
          </a>
        </div>
      </div>
    </section>;
}